<template>
  <div class="NotFound pa-4">
    <v-flex offset-sm3 xs12 sm6 md6>
      <v-layout wrap align-center>
        <v-flex xs12 sm12 md6>
          <div class="text mb-2">
            <span class="text-big mb-2" v-html="$t('common.mmm')"></span>
            <span
              class="text-medium mb-2"
              v-html="$t('common.notLookedForPage')"
            ></span>
            <span
              class="text-small mb-2"
              v-html="$t('common.linkBrokenOrPageRemoved')"
            ></span>
            <v-layout wrap align-center>
              <v-btn
                color="primary"
                class="button-rounded"
                v-html="$t('common.takeMeHome')"
                @click="redirectToLastPage"
              ></v-btn>
            </v-layout>
          </div>
        </v-flex>
        <v-flex offset-sm1 xs12 sm2 md2>
          <img
            src="@/flit2go-web-core/assets/not-found.svg"
            class="image"
            alt="not-found"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { OWNERS_HOME } from "@/modules/Owners/routesInterface";

export default {
  name: "Error",
  computed: {
    ...mapState(["auth"]),
  },
  destroyed() {
    this.$store.commit("auth/SET_LAST_ROUTE_VISITED", "");
  },
  methods: {
    redirectToLastPage() {
      if (this.auth.lastRouteVisited && this.auth.lastRouteVisited.length > 0) {
        this.$router.push(this.auth.lastRouteVisited);
      } else {
        this.$router.push(OWNERS_HOME);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.NotFound {
  min-height: calc(100vh - 60px);
  width: 100vw;

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    margin-right: 25%;
  }

  .text-big {
    font-size: 9em;
    font-weight: bold;
  }

  .text-medium {
    font-size: 3em;
  }

  .text-small {
    font-size: 1.5em;
  }

  .image {
    height: 400px;
    width: 500px;
  }

  @media (max-width: 1300px) {
    .image {
      height: 300px;
      width: 350px;
    }
  }

  @media (max-width: 1300px) {
    .image {
      height: 250px;
      width: 300px;
    }
  }

  @media (max-width: 1300px) {
    .image {
      height: 200px;
      width: 250px;
    }
  }
}
</style>
